module.exports = __webpack_public_path__ + "img/loading_gif.e04ddb4c.gif";